import {
	Message,
	MessageBox
} from 'element-ui'
import util from '@/libs/util.js'
import router from '@/router'
import request from '@/plugin/axios'
import axios from 'axios'


export default {
	namespaced: true,
	actions: {
		/**
		 * @description 登录
		 * @param {Object} context
		 * @param {Object} payload username {String} 用户账号
		 * @param {Object} payload password {String} 密码
		 * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
		 */
		login({
			dispatch
		}, {
			username,
			password,
			code,
			gid,
		} = {}) {
			// 创建 FormData 对象
			const formData = new FormData();
			formData.append('username', username);
			formData.append('password', password);
			// 设置请求头
			const config = {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			};
			return new Promise((resolve, reject) => {
				// 开始请求登录接口
				request({
						url: '/token',
						method: 'post',
						params: {
							code: code,
							gid: gid,
							// PC 会话单独保存，登录和主动退出均不影响移动端。
							client_type: 'd2admin'
						},
						data: formData,
						...config
					}).then(async res => {
						util.cookies.set('jwt_token', res.access_token)
						util.cookies.set('name', res.username)
						// 设置 vuex 用户信息
						await dispatch('d2admin/user/set', {
							name: res.username
						}, {
							root: true
						})
						// 用户登录后从持久化数据加载一系列的设置
						await dispatch('load')
						// 结束
						resolve()
					})
					.catch(err => {
						console.log('err: ', err)
						reject(err)
					})
			})
		},



		/**
		 * 主动退出撤销 PC 会话；鉴权失败触发的退出只清理本地状态。
		 * @param {Object} context
		 * @param {Object} payload confirm {Boolean} 是否需要确认
		 */
		logout({
			commit,
			dispatch
		}, {
			confirm = false,
			revoke = true
		} = {}) {
			/**
			 * 主动退出先通知后端撤销该账号 PC 会话；请求失败仍清理本地凭据。
			 */
			async function logout() {
				const token = util.cookies.get('jwt_token')
				if (revoke && token) {
					try {
						// 使用原始客户端，避免退出接口的 401 再触发全局退出拦截器。
						await axios.post(process.env.VUE_APP_API + '/logout', null, {
							headers: { Authorization: `Bearer ${token}` },
							timeout: 5000
						})
					} catch (error) {
						// 网络故障不应阻止清除设备上的令牌。
					}
				}
				// 删除cookie
				util.cookies.remove('jwt_token')
				util.cookies.remove('name')
				util.cookies.remove('fun_auth_keys')
				// 清空 vuex 用户信息
				await dispatch('d2admin/user/set', {}, {
					root: true
				})
				// 跳转路由
				router.push({
					name: 'login'
				})
			}
			// 判断是否需要确认
			if (confirm) {
				commit('d2admin/gray/set', true, {
					root: true
				})
				return MessageBox.confirm('确定要注销当前用户吗', '注销用户', {
						type: 'warning'
					})
					.then(() => {
						commit('d2admin/gray/set', false, {
							root: true
						})
						return logout()
					})
					.catch(() => {
						commit('d2admin/gray/set', false, {
							root: true
						})
						// Message({
						//   message: '取消注销操作'
						// })
					})
			} else {
				return logout()
			}
		},
		/**
		 * @description 用户登录后从持久化数据加载一系列的设置
		 * @param {Object} context
		 */
		load({
			dispatch
		}) {
			return new Promise(async resolve => {
				// DB -> store 加载用户名
				await dispatch('d2admin/user/load', null, {
					root: true
				})

				// DB -> store 加载主题
				await dispatch('d2admin/theme/load', null, {
					root: true
				})

				// DB -> store 加载页面过渡效果设置
				await dispatch('d2admin/transition/load', null, {
					root: true
				})

				// DB -> store 持久化数据加载上次退出时的多页列表		
				await dispatch('d2admin/page/openedLoad', null, {
					root: true
				})

				// DB -> store 持久化数据加载侧边栏数据
				await dispatch('d2admin/menu/asideMenuLoad', null, {
					root: true
				})

				// DB -> store 持久化数据加载侧边栏折叠状态
				await dispatch('d2admin/menu/asideCollapseLoad', null, {
					root: true
				})

				// 只从浏览器读取当前账号的布局，菜单偏好加载后再恢复临时折叠。
				await dispatch('d2admin/fullscreen/load', null, {
					root: true
				})

				// DB -> store 持久化数据加载全局尺寸
				await dispatch('d2admin/size/load', null, {
					root: true
				})

				// DB -> store 持久化数据加载颜色设置
				await dispatch('d2admin/color/load', null, {
					root: true
				})

				// end
				resolve()
			})
		}
	}
}
